import React from "react";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

// styles
import useStyle from "./styles";

const PropertyUnitTypeSelectorSkeleton = ({}) => {
  const styles = useStyle();
  return (
    <Box className={styles.wrapperUnitTypeSelectorSkeleton}>
      <Skeleton animation="wave" height="40px" variant="rect" width="70px" />
      <Box className={styles.containerUnitTypeSelector}>
        {Array.from({ length: 7 }).map((_, index) => (
          <Skeleton
            key={index}
            animation="wave"
            height="40px"
            variant="rect"
            width="150px"
            style={{ borderRadius: "8px" }}
          />
        ))}{" "}
        <Skeleton
          animation="wave"
          height="40px"
          variant="rect"
          width="30px"
          style={{ borderRadius: "8px" }}
        />
      </Box>
    </Box>
  );
};

export default PropertyUnitTypeSelectorSkeleton;
